import { formatTime, penaltyLabel } from '@shared/format.js';
import { effectiveTime } from '@shared/stats.js';

export default function SolveList({ solves, onDelete, dense = false }) {
  if (!solves || solves.length === 0) {
    return (
      <div className="text-center text-sm text-slate-500 py-8">
        还没有成绩，快去计时器刷一把吧
      </div>
    );
  }
  const rows = [...solves].reverse();
  return (
    <ul className="divide-y divide-slate-700/40">
      {rows.map((s, i) => {
        const eff = effectiveTime(s);
        return (
          <li key={s.id} className={`flex items-center gap-3 ${dense ? 'py-1.5' : 'py-2.5'}`}>
            <span className="w-8 text-center text-sm text-slate-500 font-mono">
              {solves.length - i}
            </span>
            <span className={`font-mono tabular-nums ${s.penalty === 'dnf' ? 'text-danger' : s.penalty === '+2' ? 'text-warn' : 'text-slate-100'}`}>
              {s.penalty === 'dnf' ? 'DNF' : formatTime(eff)}
              {s.penalty === '+2' && <span className="text-[10px] text-warn ml-1">+2</span>}
            </span>
            <span className="hidden sm:block text-xs text-slate-500 truncate font-mono max-w-[240px]">
              {s.scramble}
            </span>
            <span className="text-xs text-slate-500 ml-auto shrink-0">
              {new Date(s.created_at).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false })}
            </span>
            {onDelete && (
              <button
                onClick={() => onDelete(s)}
                className="text-slate-600 hover:text-danger text-sm px-1 shrink-0"
                title="删除这把成绩"
              >
                ✕
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
